/*
 * @Author: Suroc
 * @Date: 2024-07-11 14:15:56
 * @LastEditTime: 2025-01-11 22:54:47
 * @Description: 
 */
const ja = {
  // 头部导航
  Header: {
    SuperMarket: "CCR LAND",
    Connect: "ウォレット接続",
  },
  // 底部导航
  Footer: {
    Home: "ホーム",
    Mining: "農場",
    Profit: "取引",
    Flst: "NFT",
    Team: "マイページ",
  },
  // 首页
  Home: {
    Account: "アカウント",
    Share: "シェア",
    Reference: "紹介者",
    BindWallet: "ウォレットをバインドしてください",
    Ecological: "マイニングマシン",
    Pledge: "ステーキング",
    Conduct: "資産管理",
    ToLoan: "融資",
    Metaverse: "メタバース",
    ChainGame: "ブロックチェーンゲーム",
    ShoppingMall: "モール",
    SwapBut: "探検",
  },
  // 矿机
  Mint: {
    OnSale: "販売中",
    StopSelling: "販売終了",
    F1MiningMachine: "F1マイニングマシン",
    F2MiningMachine: "F2マイニングマシン",
    F3MiningMachine: "F3マイニングマシン",
    F4MiningMachine: "F4マイニングマシン",
    F5MiningMachine: "F5マイニングマシン",
    Authorize: "承認",
    BuyNow: "今すぐ購入",
    PurchaseFLST: "FLST購入",
  },
  // 收益
  Profit: {
    Hold: "保有マシン価値",
    UnStatic: "未受領静的収益",
    UnDynamics: "未受領動的収益",
    StaticTotal: "静的総収益（受領済）",
    DynamicTotal: "動的総収益（受領済）",
    MyIncome: "総収益",
    Receive: "受け取り",
    MyRecord: "収益記録",
    Money: "金額（U）",
    Quantity: "トークン数",
    Time: "時間",
  },
  // 团队
  Team: {
    SuperiorAddress: "上位アドレス",
    Performance: "実績",
    TeamSize: "チーム人数",
    Referral: "直接紹介人数",
    Direct: "マイチーム",
    Address: "アドレス",
    Money: "金額（U）",
    Time: "時間",
    CopyLink: "リンクをコピー",
  },
  // 公共消息弹窗
  Prompt: {
    Admin: "アクセス権限なし",
    AdminInfo: "異常取得",
    AdminModified: "変更成功",
    AdminModification: "変更失敗",
    PurchaseSucceeded: "購入成功",
    PurchaseFailed: "購入失敗",
    BindingSucceeded: "バインド成功",
    BindingFailed: "バインド失敗",
    ConnectWallet: "ウォレットを接続してください",
    Confirm: "確認",
    Cancel: "キャンセル",
    GoGetIt: "受け取りへ",
    SoldOut: "完売",
    NotYetDev: "未開放",
    NewIssueSuccess: "受け取り成功",
    NewIssueError: "受け取り失敗",
    TransactionErr: "取引失敗",
    BalanceErr: "残高不足",
    USDTBalanceErr: "USDT残高不足",
    FLSTBalanceErr: "FLST残高不足",
    AllowanceErr: "承認不足",
    AllowanceSuccess: "承認成功",
    InviteInfo1: "あなたは",
    InviteInfo2: "からの招待です。関係をバインドしますか？",
    ProfitInfo: "未受領の収益があります。受け取ってから購入してください",
    ProfitInfo2: "未受領の収益はありません",
    Fail: "エラー",
  },
  nongC: {
    Home: "ホーム",
    Farm: "農場",
    Trade: "取引",
    NFT: "NFT",
    Mine: "マイページ",
    Share: "シェア",
    Referrer: "紹介者",
    Lv: "現在のレベル",
    Bal: "残高",
    CHZSoil: "黒カルシウム土",
    KSTSoil: "栗カルシウム土",
    SRZSoil: "褐カルシウム土",
    GRZSoil: "灰カルシウム土",
    Plant: "植える",
    Harvest: "収穫",
    Buy: "購入",
    TaxRt: "税率",
    Prc: "価格",
    Qty: "数量",
    Mkt: "マーケット",
    Mint: "ミント",
    BBox: "ブラインドボックス",
    BuyBBox: "ブラインドボックス購入",
    SellOrder: "売り注文",
    SellMarket: "出品",
    Cancel: "キャンセル",
    Claim: "受け取り",
    ContriDiv: "貢献配当の代理受け取り",
    EquityDiv: "権益配当の代理受け取り",
    EquityVal: "権益価値",
    ContriVal: "貢献価値",
    DivList: "配当リスト",
    MyTeam: "マイチーム",
    MyDown: "ダウンライン",
    MyUpss: "アップライン",
    TeamMaxLv: "チーム最高レベル",
    DirectRefPerf: "直接紹介実績",
    Bind: "バインド",
    Sale: "販売",
    HistoryPrice: "履歴価格",
    Error: "エラー",
  },
  common: {
    crzfh: "C認証配当",
    contri: "貢献配当",
    contriAmount: "配当金額",
    myArea: "マイエリア",
    myBind: "マイバインド",
    noBind: "バインドなし",
    ktAdress: "開拓アドレス",
    crz: "C認証",
    qyz: "権益価値",
    none: "なし",
    payAmount: "支払数量",
    sale: "販売",
    amount: "数量",
    investment: "投資",
    released: "解放済",
    cycle: "周期",
    plantTime: "植え付け時間",
    lastHarvest: "前回収穫",
    harvest: "収穫",
    hgt: "黒カルシウム土",
    lgt: "栗カルシウム土",
    zgt: "褐カルシウム土",
    huigt: "灰カルシウム土",
    plantNow: "今すぐ植える",
    makeSure: "確認",
    czzqsh: "処理中、少々お待ちください...",
    ljqdts: "累計チェックイン日数：",
    dh: "交換",
    wqd: "未チェックイン",
    dqd: "チェックイン待ち",
    kfzqdd: "開発中、しばらくお待ちください",
    gqbzwjrqx: "このウォレットにアクセス権限がありません",
    zwkf: "未開放",
    sqcg: "承認成功",
    sqsb: "承認失敗",
    zzcg: "ミント成功",
    zzsb: "ミント失敗",
    dkcg: "開封成功",
    dksb: "開封失敗",
    cg: "成功",
    sb: "失敗",
    open: "開く",
    buy: "購入",
    free: "無料",
    zzhqsj: "データ取得中",
    zwtjr: "紹介者なし",
    destroy: "破壊",
    sywcc: "未生産残量",
    dhfm: "10日23時間15分15秒",
    xcrq: "次回日付",
    zwzsdnft: "販売中のNFTなし",
    mc: "名称：",
    fortyfiveDay: "45日",
    token: "トークン",
    price: "価格", 
    total: "合計",
    uybind: "バインドしますか",
    zgyqmm: "この招待コード？",
    zwyqm: "招待コードなし",
    wcxdyqm: "招待コードが見つかりません",
    bindSuccess: "バインド完了",
    zwkf: "未開放",
    lq: "受け取り",
    fail: "失敗",
    mygdl: "これ以上ありません",
    jine: "金額：",
    shijian: "時間：",
    tq: "引き出し",
    tqd: "引き出し済",
    dsf: "解放待ち",
    zzsf: "解放中",
    sfwc: "解放完了",
    jz: "価値：",
    zz: "植える",
    zq: "周期",
    Hour: "時間",
    Day: "日",
    Min: "分",
    Sec: "秒",
    limit: "残り利用可能",
    tq: "奪う",
  },
};

export default ja;